import React from 'react';
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
} from '@mui/material';

export interface SelectOption {
	value: string;
	label: string;
}

interface LabeledSelectProps {
	label: string;
	value: string;
	dataCy: string;
	name: string;
	options: SelectOption[];
	onChange: (event: SelectChangeEvent<string>) => void;
	disabled?: boolean;
}

// Shared outlined FormControl/Select/MenuItem rendering used by the
// cost-table "Cost Table"/"Apply to" fields and the custom-cost "Cost per"
// field, so the three near-identical selects don't drift or duplicate.
export const LabeledSelect = ({
	label,
	value,
	dataCy,
	name,
	options,
	onChange,
	disabled,
}: LabeledSelectProps) => (
	<FormControl variant="outlined" fullWidth disabled={disabled}>
		<InputLabel>{label}</InputLabel>
		<Select
			value={value}
			data-cy={dataCy}
			name={name}
			onChange={onChange}
			label={label}>
			{options.map(item => (
				<MenuItem key={item.value} value={item.value}>
					{item.label}
				</MenuItem>
			))}
		</Select>
	</FormControl>
);
